import type { CSSProperties } from 'react'
import logo from '../../assets/prism_logo_no_tagline.svg'

interface PrismLogoProps {
  className?: string
  style?: CSSProperties
}

export function PrismLogo({ className = '', style }: PrismLogoProps) {
  return (
    <img
      src={logo}
      alt="Prism Data Platform"
      className={className}
      style={{ width: '120px', height: 'auto', ...style }}
    />
  )
}
